import { render } from "./Question.vue?vue&type=template&id=59d554f7&scoped=true&ts=true"
import script from "./Question.vue?vue&type=script&lang=ts"
export * from "./Question.vue?vue&type=script&lang=ts"

import "./Question.vue?vue&type=style&index=0&id=59d554f7&scoped=true&lang=scss"

import exportComponent from "/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d554f7"]])

export default __exports__